import VueI18n from 'vue-i18n';
import { RawLocation, Route } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import { DEFAULT_EVENT_FILTERS, EventFilter } from '@front-app/views/home/events/EventEnum';
import { PhoenixRouteConfig } from '../Model';
import { EventListQuery } from '../util/eventListQuery';
import { getAsArray } from '../util/getFromRequest';
import { admin } from './event/admin';

export const eventRoutes: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('page.title.events.all-my-events') as string;
			},
		},
		path: 'events/',
		name: Routes.EVENTS,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			const requestedFilters = (getAsArray(route.query[EventListQuery.FILTERS]) as EventFilter[])
				.filter((filter) => Object.values(EventFilter).includes(filter));
			const currentAccessFilters = requestedFilters.length > 0 ? requestedFilters : DEFAULT_EVENT_FILTERS;
			const currentTopicFilters = getAsArray(route.query[EventListQuery.TOPIC]);
			const currentTypeFilters = getAsArray(route.query[EventListQuery.TYPE]);
			return {
				currentTypeFilters,
				currentTopicFilters,
				currentAccessFilters,
			};
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		component: (): Vue => import(/* webpackChunkName: "events" */ '@front-app/views/home/Events.vue'),
	},
	{
		meta: {
			title(i18n: VueI18n): string {
				// TODO: Add group title here as well, somehow
				return i18n.t('events.event') as string;
			},
			trappRoute(to: Route): string {
				return `/fvgbd.shtml?gd=${to.params.eventId}`;
			},
			loginRoute(to: Route): RawLocation {
				return {
					name: Routes.EVENT_LOGIN,
					params: to.params,
				};
			},
		},
		path: 'events/:eventId/',
		name: Routes.EVENT,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				eventId: route.params.eventId,
			};
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		component: (): Vue => import(/* webpackChunkName: "event" */ '@front-app/views/home/Event.vue'),
	},
	...admin,
];
